import React from 'react'
import { useStatusReportContext } from '../../statusReportContext'
import StatusReportSummaryBoardLayout from './components/StatusReportSummaryBoardLayout'

function ClientStatusReportSummaryDefaultLayout (props) {
  const { report, statuses, isLoading } = useStatusReportContext()

  return (
    <StatusReportSummaryBoardLayout
      {...props}
      report={report}
      statuses={statuses}
      loading={isLoading}
    />
  )
}

ClientStatusReportSummaryDefaultLayout.propTypes = {}

export default ClientStatusReportSummaryDefaultLayout
